/**
 * Custom Arabic translation handler for Aknaf Mubkhara Set product
 * This script translates variant option values from English to Arabic
 * when the site is viewed in Arabic locale.
 */

(function() {
  'use strict';

  // Check if we're on the Arabic site and on the Aknaf product page
  const isArabic = document.documentElement.lang === 'ar' || 
                   document.querySelector('html[lang="ar"]') !== null ||
                   window.location.pathname.includes('/ar/');
  
  // Only run on the Aknaf Mubkhara Set product page
  const isAknafProduct = window.location.pathname.includes('aknaf-mubkhara-set');
  
  if (!isArabic || !isAknafProduct) {
    return;
  }

  // Translation mappings for Aknaf product variant values
  const translations = {
    // Mubkhar Color options
    'Dark Wood': 'خشب داكن',
    'Light Wood': 'خشب فاتح',
    'Green Wood': 'خشب أخضر',
    'Blue wood': 'خشب أزرق',
    'Yellow Wood': 'خشب أصفر',
    'grap': 'عنابي',
    'Salmon': 'سلمون',
    'Green': 'أخضر',
    'Black': 'أسود',
    'Beige': 'بيج',
    'Blue': 'أزرق',
    'Yellow': 'أصفر',
    'Maroon': 'عنابي',
    'Pink': 'وردي',
    'Light Pink': 'وردي فاتح',
    
    // Charcoal Tong Color options
    'Bronze': 'برونزي',
    'Gold': 'ذهبي',
    'Peach': 'خوخي',
    'Silver': 'فضي',
    'Grey': 'رمادي',
    
    // Charcoal Size options
    'Mini': 'صغير',
    'Small': 'صغير',
    'Medium': 'متوسط',
    'Large': 'كبير'
  };

  /**
   * Translate a value from English to Arabic
   */
  function translateValue(value) {
    if (!value) return value;
    return translations[value] || value;
  }

  /**
   * Update all option value displays with Arabic translations
   */
  function updateOptionValues() {
    // Find all option value display elements
    const optionValueElements = document.querySelectorAll('.option_value');
    
    optionValueElements.forEach(element => {
      const englishValue = element.textContent.trim();
      const arabicValue = translateValue(englishValue);
      
      if (arabicValue !== englishValue && arabicValue) {
        element.textContent = arabicValue;
      }
    });

    // Also update button labels for non-color options
    const optionButtons = document.querySelectorAll('.product__item-option .button__inner');
    optionButtons.forEach(button => {
      const englishValue = button.textContent.trim();
      const arabicValue = translateValue(englishValue);
      
      if (arabicValue !== englishValue && arabicValue) {
        button.textContent = arabicValue;
      }
    });
  }

  /**
   * Override the renderProductInformation method to include translation
   */
  function patchVariantHandler() {
    // Wait for the variant radios detail element to be available
    const variantRadios = document.querySelector('variant-radios-detail');
    
    if (!variantRadios) {
      return;
    }

    // Create a MutationObserver to watch for changes in option values
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList' || mutation.type === 'characterData') {
          const target = mutation.target;
          
          // Check if the mutation is on an option_value element or its parent
          if (target.classList && target.classList.contains('option_value')) {
            const englishValue = target.textContent.trim();
            const arabicValue = translateValue(englishValue);
            
            if (arabicValue !== englishValue) {
              target.textContent = arabicValue;
            }
          } else if (target.parentElement && target.parentElement.classList.contains('option_value')) {
            const englishValue = target.parentElement.textContent.trim();
            const arabicValue = translateValue(englishValue);
            
            if (arabicValue !== englishValue) {
              target.parentElement.textContent = arabicValue;
            }
          }
        }
      });
    });

    // Observe all option value elements
    document.querySelectorAll('.option_value').forEach(element => {
      observer.observe(element, {
        characterData: true,
        childList: true,
        subtree: true
      });
    });
  }

  /**
   * Initialize the Arabic translation handler
   */
  function init() {
    // Initial translation on page load
    updateOptionValues();
    
    // Set up mutation observer for dynamic updates
    patchVariantHandler();
    
    // Also listen for custom variant change events
    document.addEventListener('variant:changed', function() {
      // Small delay to ensure DOM is updated
      setTimeout(updateOptionValues, 50);
    });

    // Listen for radio button changes with immediate and delayed translation
    document.addEventListener('change', function(e) {
      if (e.target.type === 'radio' && e.target.name) {
        // Check if it's a product option
        if (e.target.form && e.target.form.id && e.target.form.id.includes('product-form')) {
          // Translate immediately
          updateOptionValues();
          // And again after a delay to catch theme.js updates
          setTimeout(updateOptionValues, 10);
          setTimeout(updateOptionValues, 50);
          setTimeout(updateOptionValues, 100);
        }
      }
    });

    // Also watch for click events on color swatches
    document.addEventListener('click', function(e) {
      if (e.target.closest('.product__color-swatch-option') || 
          e.target.closest('.product__item-option')) {
        setTimeout(updateOptionValues, 10);
        setTimeout(updateOptionValues, 50);
        setTimeout(updateOptionValues, 100);
      }
    });

    // Periodic check to ensure translations stay in place
    setInterval(updateOptionValues, 500);
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();


